import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

import { useUserSplit } from '../useUserSplit';
import { SplitNames, TreatmentTypes } from '../useSplitSdkConfig/constants';

export const useDataDogRecording = () => {
  const { treatment } = useUserSplit(SplitNames.DataDogRecording);

  const isTreatmentOn = treatment === TreatmentTypes.ON;

  useEffect(() => {
    if (isTreatmentOn) {
      try {
        datadogRum.startSessionReplayRecording();
      } catch (e: unknown) {
        datadogLogs.logger.error(
          'Not able to initialize datadog session replay recording',
          e as object,
        );
      }
    }
  }, [isTreatmentOn]);
};
